import { useState } from "react";

export const useFileSelector = () => {
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const selectFile = async (
    callback?: (selectedFile: string | null) => void
  ) => {
    try {
      setIsLoading(true);
      setError(null);

      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      return new Promise<void>((resolve) => {
        input.onchange = async (event) => {
          const target = event.target as HTMLInputElement;
          const file = target.files?.[0];

          if (file) {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = (reader.result as string).split(",")[1];
              const base64Data = `data:image/jpeg;base64,${base64}`;
              setSelectedFile(base64Data);
              callback?.(base64Data);
              resolve();
            };
            reader.onerror = () => {
              setError(new Error("Failed to read file"));
              resolve();
            };
            reader.readAsDataURL(file);
          } else {
            resolve();
          }
        };

        input.click();
      });
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Failed to select file"));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    selectFile,
    selectedFile,
    isLoading,
    error
  };
};
